(function ($) {
  Drupal.behaviors.contactUsForm = {
    attach: function(context, settings) {
      var $contactUsPage = $('.contact-us-page', context);
      var $contactForm = $('.contact-form', context);
      var $confirmation = $('.contact-form-confirm', context);
      var $questionTypes = $('.contact-form__section--question-types', $contactForm);
      var $radios = $('input[type=radio], [type=text]', $questionTypes);
      var $questionTypeField = $('.contact-form__question-type-field', $contactForm);
      var $addressForm = $('.address-form', $contactForm);
      var $addressFields = $('.address-form__address-fields', $addressForm);
      var isMobile = $('body').hasClass('device-mobile');

      function _changeRadio() {
        var checkSameCategory = [];
        // If a radio changes, iterate through all radios and show any relavent
        // sub-elements.
        $radios.each(function() {
          var id = $(this).attr('id');
          var value  = $(this).val();
          $('[data-cf-show-if=' + id + ']', $contactForm).toggle($(this).is(':checked'));
          // Because we're using nested radios we have to control the actual
          // QUESTION field with JS
          if ($(this).is(':checked')) {
           checkSameCategory.push(id);
            if ($(this).is('[data-requires-address]')) {
              $addressFields.addClass('required');
              _setRequiredPlaceholders(true);
            } else {
              $addressFields.removeClass('required');
              _setRequiredPlaceholders();
            }
            $inputField = $(this).closest( "div" ).find("input.field");
            // To check if user select the parent and child questions and current selected question and previous selected questions
            if (checkSameCategory.length == 2 && checkSameCategory[1].indexOf(checkSameCategory[0]) !== -1 ) {
              if($inputField.length == 0) { // Check child question has one more level child questions
              $questionTypeField.val($(this).val());
            } else {
                $inputField.each(function() {
                  if ($(this).val()) { // Check if selectd question has child question
                    $questionTypeField.val(value);
                    return false;
                  } else {
                    $questionTypeField.val("");
                  }
                });
              }
            } else { // If user selected parent question then reset the previous selected question
              $questionTypeField.val("");
            }
         }
        });
      }

      function scrollToTopErrorMessage () {
        if (isMobile) {
          $("body").animate({
             scrollTop: $contactUsPage.position().top
          });
        } else {
          $(window).scrollTop(0);
        }
      }

      function _setRequiredPlaceholders(required) {
        if (!isMobile) return;
        $('.required-field', $addressFields).each(function(){
          var placeholder = $(this).attr('placeholder').replace('* ', '');
          var newPlaceholder = required ? '* ' + placeholder : placeholder;
          $(this).attr('placeholder', newPlaceholder);
        });
        $('select.required-select', $addressFields).each(function(){
          var $firstOption = $('option', this).first();
          var placeholder = $firstOption.text().replace('* ', '');
          var newPlaceholder = required ? '* ' + placeholder : placeholder;
          $firstOption.text(newPlaceholder);
        });
      }

      $radios.on('change', _changeRadio);

      $contactForm.on('submit', function(event) {
        event.preventDefault();
        if($contactForm.data('highlight-error-fields')) {
          $('.field', $contactForm).removeClass("error");
          $('.selectBox', $contactForm).removeClass("error");
        }
        var $submitButton = $('.js-contact-submit');
        $submitButton.attr('disabled', true);
        if ($submitButton.attr('data-loading').length) {
          $submitButton.val($submitButton.attr('data-loading'));
        }

        // Put the form values into an object
        var paramArr = $contactForm.serializeArray();
        var paramObj = {};
        $.each(paramArr, function(index, param) {
          paramObj[param.name] = param.value;
        });

        // Loading Button
        var enableLoading = $('.js-loading-message', $contactForm).length > 0;
        var $btnElements = $('.js-loading-message, .js-contact-submit', $contactForm);
        if (enableLoading) {
          $btnElements.toggleClass('hidden');
        }

        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: [paramObj],
          onSuccess: function(jsonRpcResponse) {
            $contactForm.add($confirmation).toggle();
            scrollToTopErrorMessage();
          },
          onFailure: function (jsonRpcResponse) {
            var errorObjectsArray = jsonRpcResponse.getMessages();
            generic.showErrors(errorObjectsArray);
            if($contactForm.data('highlight-error-fields')) {
              for(var i = 0; i < errorObjectsArray.length; i++) {
                for(var j = 2; j < errorObjectsArray[i].tags.length; j++){
                  var fieldTags = errorObjectsArray[i].tags[j].substr(6).toUpperCase();
                  $("[name='"+fieldTags+"']").addClass("error");
                  if($("[name='"+fieldTags+"']").hasClass("selectBox")) {
                    $("[name='"+fieldTags+"'] ~ a").addClass("error");
                  }
                }
              }
            }
            $submitButton.attr('disabled', false);
            if ($submitButton.attr('data-submit').length) {
              $submitButton.val($submitButton.attr('data-submit'));
            }
            scrollToTopErrorMessage();
            if (enableLoading) {
              $btnElements.toggleClass('hidden');
            }
          }
        });
      });

      _changeRadio();
    }
  };
})(jQuery);

